export class IsQueuedValueConverter {
  public toView(services, value = true) {
    return services.filter((it) => it.IsInPipelineQueue == value);
  }
}
